module.exports = __webpack_public_path__ + "static/media/game_quest_mobile_es.226306c2.png";